module.exports = __webpack_public_path__ + "src/components/games/assets/2048Stack/2.png";